import { render, staticRenderFns } from "./ImageArticle.vue?vue&type=template&id=47b7d191&scoped=true"
import script from "./ImageArticle.vue?vue&type=script&lang=js"
export * from "./ImageArticle.vue?vue&type=script&lang=js"
import style0 from "./ImageArticle.vue?vue&type=style&index=0&id=47b7d191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7d191",
  null
  
)

export default component.exports